exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UiCardField_container_183c-{position:relative;width:100%}.UiCardField_systemIcon_4ck26{position:absolute;top:21px}body[style*=\"direction: ltr\"] .UiCardField_systemIcon_4ck26{right:0}body[style*=\"direction: rtl\"] .UiCardField_systemIcon_4ck26{left:0}", ""]);

// exports
exports.locals = {
	"container": "UiCardField_container_183c-",
	"systemIcon": "UiCardField_systemIcon_4ck26"
};